import {MyAppointmentsEnum} from 'presentation/constants';
import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';

export const MY_APPOINTMENT_DETAILS_PATH = {
	[BookingTypeEnum.HEALTH]: MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_HEALTH,
	[BookingTypeEnum.TELEHEALTH]: MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_TELEHEALTH,
	[BookingTypeEnum.ODONTO]: MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_ODONTO,
	[BookingTypeEnum.EXAM]: MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_EXAM,
	[BookingTypeEnum.SURGERY]: MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_SURGERY,
};
